function MessagesLogMain() {
  return null;
}

export default MessagesLogMain;
